import App from "@/App.vue";

export default [
  {
    path: "/meu-perfil",
    name: "me",
    component: App,
    redirect: { name: "me info" },
    children: [
      {
        path: "",
        name: "me info",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MeInfo.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Perfil",
              disabled: false,
              link: false,
              to: { name: "me" }
            }
          ],
          displayName: "Seus Dados - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
